(function (){
    const API_URL = 'https://api.syrokan.cc/';
    const CACHE_KEY = 'country_code_cache';
    const CACHE_EXPIRY = 600000;
    
    const DOMAIN_LIST = [
        'au.essenther.com', 'us.essenther.com', 'shop.essenther.com',
        'us.inlyric.com', 'shop.inlyric.com',
        'au.crzyoga.com', 'ca.crzyoga.com', 'de.crzyoga.com','mx.crzyoga.com','uk.crzyoga.com', 'us.crzyoga.com', 'shop.crzyoga.com',
        'au.momanda.cc', 'ca.momanda.cc', 'eu.momanda.cc', 'uk.momanda.cc', 'us.momanda.cc', 'shop.momanda.cc',
        'us.solbrace.com', 'shop.solbrace.com'
    ];
    
    const EU_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
    
    function getCachedCountryCode() {
        try {
            const cache = localStorage.getItem(CACHE_KEY);
            if (!cache) return null;
            
            const { countryCode, timestamp } = JSON.parse(cache);
            if (Date.now() - timestamp > CACHE_EXPIRY) {
                localStorage.removeItem(CACHE_KEY);
                return null;
            }
            
            return countryCode;
        } catch (error) {
            return null;
        }
    }
    
    function cacheCountryCode(countryCode) {
        try {
            localStorage.setItem(CACHE_KEY, JSON.stringify({
                countryCode,
                timestamp: Date.now()
            }));
        } catch (error) {}
    }
    
    async function fetchCountryCode() {
        try {
            const response = await fetch(API_URL);
            if (!response.ok) return '';
            
            let countryCode = (await response.text()).toUpperCase();
            if (countryCode.length !== 2) return '';
            
            cacheCountryCode(countryCode);
            return countryCode;
        } catch (error) {
            return '';
        }
    }
    
    function processCountryCode(domain, code) {
        if (domain === 'inlyric.com' && ['AU', 'NZ'].includes(code)) return 'AUS';
        if (domain === 'momanda.cc' && EU_COUNTRIES.includes(code)) return 'EU';
        if (['GB', 'IE'].includes(code)) return 'UK';
        if (['AU', 'NZ'].includes(code)) return 'AU';
        return code;
    }
    
    async function executeRedirect() {
        let countryCode = getCachedCountryCode() || await fetchCountryCode();
        if (countryCode.length !== 2) return false;
		
		const parts = window.location.hostname.toLowerCase().split('.');
		const domain1 = parts.slice(-2).join('.');
		const domain2 = parts.slice(-3).join('.');
        const processedCode = processCountryCode(domain1, countryCode);
        let targetDomain = processedCode.toLowerCase() + '.' + domain1;
        
        // 非预期域名跳shop子域名
        if (!DOMAIN_LIST.includes(targetDomain)) {
            targetDomain = 'shop.' + domain1;
        }
        
        // 当前页面的路径+查询参数
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search;
        const fullPath = currentPath + currentSearch;
        
        // 仅当目标域名≠当前域名、且目标域名合法时重定向
        if (domain2 !== targetDomain && DOMAIN_LIST.includes(targetDomain)) {
            // 拼接完整URL：//目标域名 + 路径 + 查询参数
            window.location.href = '//' + targetDomain + fullPath;
        }
    }
    
    if (!window._redirectExecuting) {
        window._redirectExecuting = true;
        executeRedirect().catch(() => {}).finally(() => {
            window._redirectExecuting = false;
        });
    }
})();